import { Fragment } from "react"
import { observer } from "mobx-react"

import { useStore, Meta } from "../lib"
import { Header, Footer, MainNavigation } from "../organisms"

import { CommonTemplate } from "./common-template"

import type { ReactElement } from "react"
import type { MetaProps } from "../lib"
import type { CommonTemplateProps } from "./common-template"

type PageProps = {
  className?: string
  meta?: MetaProps
  navigation?: ReactElement<typeof MainNavigation> | null
  seoH1?: string
  accessLanguages?: string[]
} & CommonTemplateProps

export const Page = observer(function Page(props: PageProps) {
  const {
    GlobalModel: { lang, isMenuOpened },
  } = useStore()

  const {
    className,
    children,
    accessLanguages,
    meta = {},
    navigation = <MainNavigation />,
    header = <Header />,
    seoH1 = "",
    footer = <Footer accessLanguages={accessLanguages} />,
    ...otherProps
  } = props

  return (
    <Fragment key={lang}>
      <Meta {...meta} />
      {navigation && isMenuOpened ? (
        <div className="absolute z-50 inset-0 bg-black bg-opacity-60 select-none">
          {navigation}
        </div>
      ) : null}
      <CommonTemplate
        header={header}
        seoH1={seoH1}
        footer={footer}
        mainClassName={className}
        {...otherProps}
      >
        {children}
      </CommonTemplate>
    </Fragment>
  )
})
